import debug from "debug";

const log = debug("cart-count");

class CartCount {
	constructor(element, options) {
		this.element = element;
		this.options = options;

		this.cartLinks = [
			...document.querySelectorAll(this.options.linkSelector),
		];

		if (!this.cartLinks.length) {
			log(
				`Missing cart link element
data-cart-count-link-selector="${this.options.cartLinkSelector}" Aborting`
			);
			return false;
		}

		this.requestTokenInput = document.querySelector(
			this.options.requestTokenInputSelector
		);

		if (!this.requestTokenInput || !this.requestTokenInput.value) {
			log("Error: Missing __RequestVerificationToken. Aborting");
			return false;
		}

		this.listenerTarget = this.options.listenerTarget
			? (this.options.listenerTarget === "window")
				? window
				: document.querySelector(this.options.listenerTarget)
			: this.element;

		if(!this.listenerTarget) {
			log(`Error: listenerTarget not found
data-cart-count-listener-target="${this.options.listenerTarget}" Aborting`);
			return false;
		}

		this.init();
	}

	init() {
		this.requestCount();
		this.watch();
	}

	watch() {
		log(this.element, this.options);

		this.listenerTarget.addEventListener(
			this.options.updateOn,
			this.requestCount.bind(this)
		);
	}

	getRequestToken() {
		return this.requestTokenInput.value;
	}

	updateCartLinkCounts(count) {
		this.cartLinks.forEach((link) => {
			const countElement =
				link.querySelector(".count") || this.makeCountElement(link);
			if (count) {
				countElement.textContent = count;
			} else {
				countElement.remove();
			}
		});
	}

	makeCountElement(link) {
		const span = document.createElement("span");
		span.classList.add("count");
		link.append(span);
		return span;
	}

	requestCount() {
		log("Requesting count");

		this.updateCartLinkCounts("…");

		fetch(this.options.endpoint, {
			method: "POST",
			body: JSON.stringify({
				__RequestVerificationToken: this.getRequestToken(),
			}),
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
				return Promise.reject(response);
			})
			.then((count) => {
				log("Count", count);
				this.updateCartLinkCounts(count);
			})
			.catch((error) => {
				log("error", error);
			});
	}
}

CartCount.DEFAULTS = {
	requestTokenInputSelector:
		'#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]',
};

export default CartCount;



// WEBPACK FOOTER //
// ./client/src/core/components/cart-count/cart-count.js